import { useState } from "react";
import { styles } from "../../../utils/styles/products-finishing-styles";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import dynamic from "next/dynamic";
const PageHead = dynamic(() => import("@/components/PageHead"));
import ProductMain from "@/components/products-revamp/product-main";
import { colors } from "@/utils/const";
import DynamicFAQSection from "@/components/DynamicFAQSection";
import StepsRow from "@/components/steps-row";
import ApplyProduct from "@/components/products-revamp/product-apply";
import CalcPopup from "@/components/products-revamp/CalcPopup";
import PgWithImgSection from "@/components/products-revamp/pg-with-img-section";
import SplitPgSection from "@/components/products-revamp/split-pg-section";
import Features from "@/components/products-revamp/features-section";
import { emptyProps, getProductPageData } from "@/services/get-product-data";
import {
  getLocalizedValue,
  getStaticTextByKey,
} from "@/utils/general-functions";
import { useSplitContentSections } from "@/hooks/product";
import { useProductLoanPackages } from "@/hooks/useProductLoanPackages";
import { getProductsText } from "../../../../locales/products";

export default function Index({
  heroData,
  featuresData,
  mainData,
  faqData,
  staticTextData,
  contentWithImageData,
  stepsData,
}) {
  const { t, locale } = useI18n();
  const products = getProductsText(locale);
  const { targetProduct, data } = useProductLoanPackages(
    products.home_furniture.id,
  );
  const [openCalc, setOpenCalc] = useState(false);
  const staticTexts = getStaticTextByKey(staticTextData?.data);
  const { fullNavySections, splitSections } =
    useSplitContentSections(contentWithImageData);

  return (
    <>
      <PageHead
        title={getLocalizedValue(mainData[0], "meta_title", locale)}
        description={getLocalizedValue(mainData[0], "meta_description", locale)}
        scripts={getLocalizedValue(mainData[0], "schema", locale)}
      />
      <Box sx={{ ...styles.container, overflow: "hidden" }}>
        {heroData?.length > 0 && (
          <ProductMain
            heroData={heroData}
            staticTexts={staticTexts}
            onApplyClick={() => {
              const formSection = document.getElementById("apply-form");
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            onCalcClick={() => setOpenCalc((prev) => !prev)}
            onExploreMoreClick={() => {
              const formSection = document.getElementById(
                "home-furniture-features",
              );
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            imgStyle={{
              mt: locale === "ar" ? { xs: 5, xl: 7 } : { xs: 5, xl: 6 },
            }}
            headerH1={true}
            shadow={true}
          />
        )}

        {fullNavySections?.length > 0 &&
          fullNavySections.map((section, index) => (
            <PgWithImgSection
              key={section.id || index}
              img={section.img}
              alt={section.alt_img}
              title={section.title?.text?.[locale]}
              titleType={section.title?.type}
              paragraph={section.description?.text?.[locale]}
              paragraphType={section.description?.type}
            />
          ))}

        <Box sx={{ position: "relative", bgcolor: colors.white }}>
          {/* <WhyProduct
            content={products.home_furniture.third_section}
            bgHeight={{ xs: "100%", md: locale == "en" ? "45%" : "50%" }}
          /> */}
          {splitSections?.length > 0 &&
            splitSections.map((section, index) => (
              <SplitPgSection
                key={section.id || index}
                img={section.img}
                alt={section.alt_img}
                title={section.title?.text?.[locale]}
                titleType={section.title?.type}
                paragraph={section.description?.text?.[locale]}
                paragraphType={section.description?.type}
                bgHeight={{
                  xs: "100%",
                  md: locale === "ar" ? "50%" : "54%",
                }}
              />
            ))}

          {/**Features section */}
          {featuresData?.length > 0 &&
            featuresData.map((section, index) => (
              <Features
                key={section?.id || index}
                section={section}
                // bgHeight={{ xs: "60%", sm: "65%", md: "40%", lg: "35%" }}
                id="home-furniture-features"
              />
            ))}
          {/* <WhyProduct
            content={products.home_furniture.why_product}
            withBg={false}
            id="home-furniture-features"
          /> */}

          {/**faq section */}

          {faqData?.length > 0 &&
            faqData.map((section, index) => (
              <DynamicFAQSection
                key={section?.id || index}
                title={
                  staticTexts?.faqs_section_title?.value?.text[locale] || ""
                }
                items={section?.faqs}
                renderHTML={true}
                variantTitle="h2"
                variantQ="h3"
              />
            ))}
        </Box>

        {/**Steps section */}
        {stepsData?.length > 0 &&
          stepsData.map((section, index) => (
            <StepsRow
              key={section.id || index}
              title={section?.title?.text?.[locale]}
              subtitle={section?.description?.text?.[locale]}
              steps={section?.items}
            />
          ))}
        <ApplyProduct
          img={heroData[0]?.img}
          title={mainData[0]?.form_title.text[locale]}
          titleType={mainData[0]?.form_title?.type}
          description={mainData[0]?.form_desc.text[locale]}
          descType={mainData[0]?.form_desc?.type}
          formType="b"
          product="19"
          source={33}
          shadow={true}
        />

        {targetProduct?.hasPlan && (
          <CalcPopup
            open={openCalc}
            onClose={() => setOpenCalc(false)}
            data={data}
            max_amount={targetProduct?.maxLimit}
            price_label={products.home_furniture.price}
          />
        )}
      </Box>
    </>
  );
}

export async function getServerSideProps() {
  try {
    const data = await getProductPageData("home furniture");
    return { props: data };
  } catch {
    return { props: emptyProps };
  }
}
